import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

// 列表
async function all (competitionId) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${competitionId}/stage`,
      method: 'GET'
    }
  )
}

async function getById (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.id}`,
      method: 'DELETE'
    }
  )
}

async function setProcessingStage (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.id}/progressing`,
      method: 'PUT'
    }
  )
}

export default {
  all,
  getById,
  insert,
  update,
  remove,
  setProcessingStage
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-stage.js